module.exports = __webpack_public_path__ + "static/img/jsldTu5@2x.34dc26a6.png";